<template>
    <div class="ScrollBar">
        <div class="adbox">
            <div class="ad">
                <span class="remen">热门业务：</span>
                <div class="scroll-container" ref="scrollContainer">
                    <div class="scroll-content" ref="scrollContent">
                        <!-- 两组相同内容用于无缝循环 -->
                        <div class="scroll-group" ref="group1">
                            <div class="service-item" v-for="(item, index) in services" :key="index">
                                <img :src="item.img" alt="业务图标">
                                {{ item.text }}
                            </div>
                        </div>
                        <div class="scroll-group" ref="group2">
                            <div class="service-item" v-for="(item, index) in services" :key="index + services.length">
                                <img :src="item.img" alt="业务图标">
                                {{ item.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ScrollBar",
    data() {
        return {
            services: [
                { img: require("@/assets/images/meiguo.png"), text: "美国外观专利申请" },
                { img: require("@/assets/images/oumeng.png"), text: "欧盟外观专利申请" },
                { img: require("@/assets/images/meiguo.png"), text: "美国商标申请" },
                { img: require("@/assets/images/hanguo.png"), text: "韩国外观专利申请" },
                { img: require("@/assets/images/meiguo.png"), text: "美国发明专利申请" },
                { img: require("@/assets/images/zhonguo.png"), text: "中国大陆专利申请" },
                { img: require("@/assets/images/zhonguo.png"), text: "中国大陆版权登记" },
                { img: require("@/assets/images/meiguo.png"), text: "美国外申请" },
            ],
            scrollSpeed: 50, // 滚动速度 (像素/秒)
            animationId: null,
            isPaused: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.initializeScroll();
            this.startScroll();
            
            // 鼠标悬停暂停
            this.$refs.scrollContainer.addEventListener('mouseenter', () => this.isPaused = true);
            this.$refs.scrollContainer.addEventListener('mouseleave', () => this.isPaused = false);
            
            // 窗口大小变化时重新初始化
            window.addEventListener('resize', this.handleResize);
        });
    },
    beforeDestroy() {
        this.stopScroll();
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initializeScroll() {
            // 计算并设置容器宽度
            const container = this.$refs.scrollContainer;
            const content = this.$refs.scrollContent;
            const group1 = this.$refs.group1;
            
            // 确保DOM已渲染
            if (!group1.offsetWidth) return;
            
            // 设置内容宽度为两组内容的总宽度
            const groupWidth = group1.offsetWidth;
            content.style.width = `${groupWidth * 2}px`;
            
            // 存储一组内容的宽度用于后续计算
            this.groupWidth = groupWidth;
        },
        startScroll() {
            let lastTime = 0;
            const container = this.$refs.scrollContainer;
            const content = this.$refs.scrollContent;
            
            const scroll = (timestamp) => {
                if (!lastTime) lastTime = timestamp;
                const deltaTime = timestamp - lastTime;
                lastTime = timestamp;
                
                if (!this.isPaused) {
                    // 计算滚动距离
                    const scrollDistance = (this.scrollSpeed * deltaTime) / 1000;
                    let currentScroll = parseFloat(content.style.transform.replace('translateX(', '')) || 0;
                    
                    // 累加滚动距离
                    currentScroll -= scrollDistance;
                    
                    // 检查是否需要重置位置以实现无缝循环
                    if (Math.abs(currentScroll) >= this.groupWidth) {
                        currentScroll = currentScroll % this.groupWidth;
                    }
                    
                    // 应用新的滚动位置
                    content.style.transform = `translateX(${currentScroll}px)`;
                }
                
                this.animationId = requestAnimationFrame(scroll);
            };
            
            this.animationId = requestAnimationFrame(scroll);
        },
        stopScroll() {
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
                this.animationId = null;
            }
        },
        handleResize() {
            // 窗口大小变化时重新初始化滚动
            this.stopScroll();
            this.initializeScroll();
            this.startScroll();
        }
    }
}
</script>

<style lang='scss' scoped>
.adbox {
    overflow: hidden;
}

.ad {
    width: 100%;
    font-size: 15px;
    text-align: center;
    display: flex;
    border-bottom: 1px solid $zhuti;

    span {
        display: flex;
        width: 160px;
        flex-shrink: 0;
        justify-content: center;
        align-items: center;
        padding: 12px 16px;
        position: relative;
        z-index: 1;
        color: $zhuti;
        background-color: white;
    }

    .scroll-container {
        overflow: hidden;
        flex-grow: 1;
        margin-left: 10px;
    }

    .scroll-content {
        display: flex;
        position: relative;
        will-change: transform;
        transition: transform 0s linear;
    }

    .scroll-group {
        display: flex;
    }

    .service-item {
        min-width: 200px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px 16px;
        background-color: white;
        color: $zhuti;

        img {
            width: 30px !important;
            height: 20px;
            margin-right: 8px;
            border-radius: 2px;
            border: 1px solid white;
        }
    }

    .service-item:nth-child(2n) {
        background-color: $zhuti;
        color: white;

        img {
            border: 1px solid $zhuti;
        }
    }

    .remen {
        font-weight: bold;
    }
}
</style>    